import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { Box, Button, Typography } from "@mui/material";

const EmptyRecentOrders = ({ handleRefreshClick }) => {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      sx={{ color: "text.secondary" }}
    >
      <ReceiptLongOutlinedIcon sx={{ fontSize: 64, mb: 2, opacity: 0.6 }} />

      <Typography variant="h6" color="text.primary">
        No orders yet today
      </Typography>

      <Typography variant="body2" sx={{ mt: 1, mb: 3 }}>
        Orders placed today will appear here once billing starts.
      </Typography>

      <Box display="flex" gap={2}>
        {/* <Button variant="contained">
          Create New Order
        </Button> */}
        <Button variant="outlined" onClick={handleRefreshClick}>
          Refresh
        </Button>
      </Box>
    </Box>
  );
};

export default EmptyRecentOrders;
